import React from "react";
import { useOutletContext } from "react-router-dom";
import { ChatWidget } from "../../components/ChatWidget";
import { toast } from "sonner";
import { Copy, ExternalLink } from "lucide-react";
import { Button } from "../../components/ui/button";

export default function Receptionist() {
  const { company } = useOutletContext();
  const publicUrl = `${window.location.origin}/c/${company?.slug}`;

  const copy = () => { navigator.clipboard.writeText(publicUrl); toast.success("Public link copied"); };

  return (
    <div className="space-y-6" data-testid="receptionist-page">
      <div>
        <h1 className="font-display text-4xl md:text-5xl tracking-tight">TEST AVA</h1>
        <p className="text-muted-foreground mt-1">Chat with your AI receptionist exactly like a customer would. Leads land in your dashboard.</p>
      </div>

      <div className="bg-[#18181b] border border-white/10 rounded-sm p-4 flex flex-col sm:flex-row sm:items-center gap-3 justify-between">
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-wider text-muted-foreground mb-1">Your shareable receptionist link</p>
          <p className="text-sm text-primary truncate" data-testid="public-link">{publicUrl}</p>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button data-testid="copy-link-btn" onClick={copy} variant="outline" size="sm" className="rounded-sm border-white/10 gap-2"><Copy className="h-3.5 w-3.5" /> Copy</Button>
          <Button onClick={() => window.open(publicUrl, "_blank")} size="sm" className="rounded-sm bg-primary hover:bg-orange-600 text-white gap-2"><ExternalLink className="h-3.5 w-3.5" /> Open</Button>
        </div>
      </div>

      <div className="h-[600px] max-w-2xl">
        <ChatWidget slug={company?.slug} />
      </div>
    </div>
  );
}
